import { MenuItem, Select } from '@mui/material';
import GTranslateRoundedIcon from '@mui/icons-material/GTranslateRounded';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [lenguage, setlenguage] = useState('en');

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setlenguage(lng);
    };

    useEffect(() => {
        const language = navigator.language || navigator.userLanguage;
        if (language.includes('es'))
            changeLanguage('es');
        else
            changeLanguage('en');
    }, []);

    return (
        <Select
            value={lenguage}
            onChange={(e) => changeLanguage(e.target.value)}
            size="small"
            variant="standard"
            disableUnderline
            IconComponent={GTranslateRoundedIcon}
            sx={{
                backgroundColor: 'transparent',
                color: 'white',
                fontSize: 14,
                '& .MuiSelect-select': {
                    paddingRight: '30px !important',
                    minWidth: '16px',
                    marginTop: '5px',
                },
                '& .MuiSelect-icon': {
                    color: 'primary.main',
                    right: '0px',
                    fontSize: '22px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
            }}
        >
            <MenuItem value="es">Español </MenuItem>
            <MenuItem value="en">English </MenuItem>
        </Select >
    );
}
export default LanguageSwitcher;
